/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_top_ups_modal_description_loading = /** @type {(inputs: { currency: NonNullable<unknown>, type: NonNullable<unknown>, lastFour: NonNullable<unknown> }) => string} */ (i) => {
	return `Estás por recargar ${i.currency} a la ${i.type} •• ${i.lastFour}`
};

const en_top_ups_modal_description_loading = /** @type {(inputs: { currency: NonNullable<unknown>, type: NonNullable<unknown>, lastFour: NonNullable<unknown> }) => string} */ (i) => {
	return `You are about to top-up ${i.currency} to ${i.type} •• ${i.lastFour}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ currency: NonNullable<unknown>, type: NonNullable<unknown>, lastFour: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const top_ups_modal_description_loading = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.top_ups_modal_description_loading(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("top_ups_modal_description_loading", locale)
	if (locale === "es") return es_top_ups_modal_description_loading(inputs)
	return en_top_ups_modal_description_loading(inputs)
};
export { top_ups_modal_description_loading as "top_ups.modal.description_loading" }